import { Carousel } from '@xing-com/carousel';
import { ModuleHeader } from '@xing-com/crate-entity-pages-common';

import { CompanyRecommendationCardSkeleton } from './company-recommendation-card.skeleton';

export const CompanyRecommendationCarouselSkeleton: React.FC = () => (
  <Carousel
    itemWidthConfined="50%"
    itemWidth="80%"
    itemWidthWide="280px"
    itemSpacingConfined="16px"
  >
    <CompanyRecommendationCardSkeleton />
    <CompanyRecommendationCardSkeleton />
    <CompanyRecommendationCardSkeleton />
  </Carousel>
);

export const CompanyRecommendationsFallback: React.FC = () => {
  return (
    <div data-testid="loadingContainer">
      <ModuleHeader headlineCopyKey="CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US" />
      <CompanyRecommendationCarouselSkeleton />
    </div>
  );
};
